import * as types from '../mutation-types';

// state
export const state = {
  enterprise: null,
  dealer: null,
};

// getters
export const getters = {
  enterprise: (state) => state.enterprise,
  dealer: (state) => state.dealer,
};

// mutations
export const mutations = {
  [types.SET_CURRENT_ENTERPRISE](state, { enterprise }) {
    state.enterprise = enterprise;
  },
  [types.RESET_ENTERPRISE](state) {
    state.enterprise = null;
  },
  [types.SET_CURRENT_DEALER](state, { dealer }) {
    state.dealer = dealer;
  },
  [types.RESET_DEALER](state) {
    state.dealer = null;
  },
};

// actions
export const actions = {
  setCurrentEnterprise({ commit }, { enterprise }) {
    commit(types.SET_CURRENT_ENTERPRISE, { enterprise });
  },
  resetEnterprise({ commit }) {
    commit(types.RESET_ENTERPRISE);
  },
  setCurrentDealer({ commit }, { dealer }) {
    commit(types.SET_CURRENT_DEALER, { dealer });
  },
  resetDealer({ commit }) {
    commit(types.RESET_DEALER);
  },
};
